/**
 * MH-41 Danh sách phiên đăng nhập / thiết bị tin cậy (đợt 3 phần C4, trả nợ D1
 * đợt 0). Mỗi phiên có nút thu hồi riêng — thu hồi một phiên không phải phiên
 * hiện tại đăng xuất thiết bị đó từ xa ngay lập tức.
 */
import { useState, type ReactNode } from 'react';
import { vi } from '../ngon-ngu/vi';
import { quanTriApi, LoiApi, type DongPhien } from '../api/quan-tri-api';
import { dungTaiDuLieu } from '../trang-thai/dung-tai-du-lieu';
import { BangDuLieu, SO_DONG_MAC_DINH, type CotBang } from '../thanh-phan/BangDuLieu';

export function MH41ThietBiTinCayPhien(): ReactNode {
  const [moc, datMoc] = useState(0);
  const [loi, datLoi] = useState<string | null>(null);
  const [thongBao, datThongBao] = useState<string | null>(null);

  const kq = dungTaiDuLieu<DongPhien[]>({
    tai: (signal) => quanTriApi.danhSachPhien(signal),
    laRong: (d) => d.length === 0,
    dangLoc: false,
    phuThuoc: [moc],
  });
  const taiLai = (): void => datMoc((x) => x + 1);

  const thuHoi = async (p: DongPhien): Promise<void> => {
    if (!window.confirm(vi.thietBiTinCayPhien.xacNhanThuHoi)) return;
    datLoi(null);
    try {
      await quanTriApi.thuHoiPhien(p.id);
      datThongBao(vi.thietBiTinCayPhien.daThuHoi);
      taiLai();
    } catch (err) {
      datLoi(err instanceof LoiApi ? err.message : 'Không thu hồi được phiên đăng nhập');
    }
  };

  const cot: CotBang<DongPhien>[] = [
    {
      khoa: 'thietBi',
      nhan: vi.thietBiTinCayPhien.cot.thietBi,
      ve: (d) => (
        <>
          {d.userAgent ?? '—'}
          {d.laPhienHienTai ? <span className="the the--chinh"> · {vi.thietBiTinCayPhien.phienHienTai}</span> : null}
        </>
      ),
    },
    { khoa: 'diaChiIp', nhan: vi.thietBiTinCayPhien.cot.diaChiIp, ve: (d) => d.diaChiIp ?? '—' },
    { khoa: 'taoLuc', nhan: vi.thietBiTinCayPhien.cot.taoLuc, ve: (d) => new Date(d.taoLuc).toLocaleString('vi-VN') },
    {
      khoa: 'hoatDongGanNhat',
      nhan: vi.thietBiTinCayPhien.cot.hoatDongGanNhat,
      ve: (d) => new Date(d.hoatDongGanNhat).toLocaleString('vi-VN'),
    },
    { khoa: 'hetHan', nhan: vi.thietBiTinCayPhien.cot.hetHan, ve: (d) => new Date(d.hetHanLuc).toLocaleString('vi-VN') },
    {
      khoa: 'hanhDong',
      nhan: '',
      ve: (d) => (
        <button type="button" className="nut nut--nho" onClick={() => void thuHoi(d)}>
          {vi.thietBiTinCayPhien.thuHoi}
        </button>
      ),
    },
  ];

  return (
    <div className="man-hinh man-hinh--phien-dang-nhap">
      <header className="man-hinh__dau">
        <h1>{vi.thietBiTinCayPhien.tieuDe}</h1>
      </header>
      <p>{vi.thietBiTinCayPhien.moTa}</p>
      {thongBao ? <p role="status">{thongBao}</p> : null}
      {loi ? <p role="alert">{loi}</p> : null}

      <BangDuLieu<DongPhien>
        nhan={vi.thietBiTinCayPhien.tieuDe}
        cot={cot}
        dong={kq.duLieu ?? []}
        khoaDong={(d) => d.id}
        trangThai={kq.trangThai}
        loi={kq.loi}
        taiLau={kq.taiLau}
        onThuLai={taiLai}
        tong={kq.duLieu?.length ?? 0}
        trang={1}
        soDongMoiTrang={SO_DONG_MAC_DINH}
        onDoiTrang={() => undefined}
        onDoiSoDong={() => undefined}
        dangLoc={false}
        onXoaLoc={() => undefined}
        moTaRong={vi.thietBiTinCayPhien.rongMoTa}
      />
    </div>
  );
}
